import styled from "styled-components";
import	fondoBlue from '../../../videos/fondoBlue.mp4'
import RowOption from '../rowOption.jsx';
import SelectConsola from"./consola.jsx";
import PreviewCard from './previewCard.jsx';

const Container=styled.div`
	width:100%;
	display:flex;
	align-items:center
`
const Info=styled.div`
	width:95%;
	border-radius:10px;
	display:flex;
	flex-direction:column;
	align-items:center;
	margin-bottom:15px;
	padding:15px
`

const ContainerPreview=styled.div`
	display:flex;	
	position:relative;
	height:100%;
	overflow:hidden;	
	width:500px;
	justify-content:center;
	align-items:center;
	
	@media (max-width: 768px){
			display:none
		}
`;


const ContainerPreviewCard=styled.div`
	height:250px;
	width:250px;
	z-index:1;
	display:flex;
	align-items:center;
	justify-content:center
`
const FondoVideo=styled.video`
	position:absolute;
	background-size:cover;
	z-index:0
`;

export default function BasicDetailGame(props){
	
	let{ value,action,estado}=props;

	return(
		<Container>			
      				<h1>Basico</h1>
 					<Info>	
 						<RowOption label="nombre" value={value.nombre} action={action} estado={estado} />
 						<RowOption label="poster" value={value.poster} action={action} estado={estado} />
 						<SelectConsola value={value.Consolas} action={action} estado={estado}/> 							
 					</Info>

 					<ContainerPreview>
 						<FondoVideo autoPlay muted loop>
 							<source src={fondoBlue} type="video/mp4" />
 						</FondoVideo>
 						<ContainerPreviewCard >
 							<PreviewCard juego={value} />
 						</ContainerPreviewCard>
 					</ContainerPreview>
 		</Container>

		)
}